import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const DocumentPreviewModal = ({ document, onClose }) => {
  if (!document) return null;

  const isImage = document?.type?.includes('image');
  const isPDF = document?.type?.includes('pdf');
  
  const handleDownload = () => {
    const link = window.document.createElement('a');
    link.href = document.url;
    link.download = document.name || 'download';
    link.target = '_blank';
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '0 B';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80">
      <div className="bg-card rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-border">
          <div className="flex items-center gap-3">
            <Icon 
              name={isImage ? 'Image' : 'FileText'} 
              size={24} 
              color="var(--color-primary)" 
            />
            <div>
              <h3 className="text-lg font-semibold text-foreground">
                {document?.title || document?.name}
              </h3>
              <p className="text-sm text-muted-foreground">
                {formatFileSize(document?.size)}
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClose}
          />
        </div>
        
        <div className="flex-1 overflow-auto p-6 bg-muted/20">
          {isImage && (
            <div className="flex items-center justify-center">
              <Image
                src={document?.url}
                alt={document?.alt}
                className="max-w-full max-h-[70vh] object-contain rounded-lg"
              />
            </div>
          )}
          
          {isPDF && (
            <iframe
              src={document.url}
              className="w-full h-full min-h-[600px] rounded-lg"
              title={document.title || document.name}
            />
          )}
        </div>
        
        <div className="flex items-center justify-end gap-3 p-4 border-t border-border">
          <Button
            variant="outline"
            iconName="Download"
            iconPosition="left"
            onClick={handleDownload}
          >
            Download
          </Button>
          <Button
            variant="default"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DocumentPreviewModal;